import React from 'react';
import { FilterGroup, Switcher } from '@lt/components';

import { i18n } from '@lt/localization';
import { SkiLift } from '@lt/components/icons-react/userflow/filters';

import styled from 'styled-components';

import type { IFilter } from '../types';

const FILTER_NAME = 'ski_distance';
const FILTER_LABEL = i18n.t('filters.distance.title');

const FilterSkiDistance = ({
  data,
  isMobile = false,
  onClear,
  className = '',
  onChange,
}: IFilter): JSX.Element => {
  const handleChange = (clickedItem) => {
    const diff = data.map(({ id, selected }) => ({
      id,
      selected: id === clickedItem.id && !selected,
    }));

    onChange({ path: FILTER_NAME, diff });
  };

  const list = data.map((button) => ({ ...button, label: button.name }));

  return (
    <FilterGroup
      className={className}
      label={FILTER_LABEL}
      showClearBtn={list.some((item) => item.selected)}
      onClear={() => onClear(FILTER_NAME)}
      isMobile={isMobile}
    >
      <FilterLift>
        <StyledSkiIcon />
        <StyledSkiSwitcher
          list={list}
          onChange={handleChange}
          order="desc"
          isMobile={isMobile}
        />
      </FilterLift>
      <StyledDesc>
        <span>{i18n.t('filters.distance.lift')}</span>
        <span>{i18n.t('filters.distance.hotel')}</span>
      </StyledDesc>
    </FilterGroup>
  );
};

const FilterLift = styled.div`
  display: flex;
  align-items: center;
`;

const StyledSkiIcon = styled(SkiLift)`
  width: 33px;
  position: relative;
  height: 46px;
  margin-right: 13px;
  top: -5px;
  flex-shrink: 0;
  path {
    fill: none;
    stroke: #919499;
  }
`;

const StyledSkiSwitcher = styled(Switcher)`
  height: 37px;
  width: 100%;
  max-width: calc(100% - 12px);
`;

const StyledDesc = styled.div`
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  font-size: 14px;
  color: #919499;
`;
export default Object.assign(FilterSkiDistance, {
  filterName: FILTER_NAME,
  filterLabel: FILTER_LABEL,
  valuesLabel: (data) =>
    i18n.t('filters.distance.value', {
      distance: `${data.find((item) => item.selected).id}`,
    }),
});
